import { ContentTypeEnum } from '@/enums/axios'
import request from '@/utils/axios'
import type { CustomerManage } from '@/apis/interface/customerManage'

const jsonHeaderConfig = {
  headers: {
    'Content-Type': ContentTypeEnum.JSON
  }
}

const FormUrlEncodedConfig = {
  headers: {
    'Content-Type': ContentTypeEnum.FORM_URLENCODED
  }
}
// 获取公海列表1
export const getCustomListApi = (
  params: CustomerManage.ReqCustomListList
): Promise<CustomerManage.ReqCustomListReturn> => {
  return request.post('/crm/track/seaManage/page', params, jsonHeaderConfig)
}
// 根据fieldCodes 拿到columnId
export const getColumnIdsByNames = (data: any) => {
  return request.post('/paas/column/getColumnIdsByNames', data, jsonHeaderConfig)
}

// 新增公海
export const addCustomListApi = (params: CustomerManage.ReqAddCustomParams) => {
  return request.post('/crm/track/seaManage/add', params, jsonHeaderConfig)
}

// 编辑公海
export const editCustomListApi = (params: CustomerManage.ReqAddCustomParams, id: string) => {
  return request.post('/crm/track/seaManage/modify?id=' + id, params, jsonHeaderConfig)
}

// 删除公海
export const deleteCustomListApi = (id: string) => {
  // return this.request<T, D>({ ...headerConfig, url, method: 'GET', params: data }, requestOptions)
  return request.request({
    ...jsonHeaderConfig,
    url: `/crm/track/seaManage/del?id=${id}`,
    method: 'Delete',
    params: null
  })
}

// 获取部门
export const getDepartmentListApi = () => {
  return request.post('/admin/department/tree', null, jsonHeaderConfig)
}

// 常用语列表
export const getCommonWordsApi = () => {
  return request.post('/crm/saas_order_follow_common_words/selectList', null, jsonHeaderConfig)
}

// 保存常用语
export const saveCommonWords = (data: any) => {
  return request.post('/crm/saas_order_follow_common_words/save', data, jsonHeaderConfig)
}

// 获取协助人数量
export const getAssistantsNumApi = (data: any) => {
  return request.post('/crm/track/assistant/count', data)
}
// 获取协助人列表
export const getAssistantsList = (data: any) => {
  return request.post('/crm/track/assistant/list', data)
}
// 新增协助人
export const addAssistants = (data: any) => {
  return request.post('/crm/track/assistant/add', data, jsonHeaderConfig)
}
// 修改协助人
export const updateAssistants = (data: any) => {
  return request.post('/crm/track/assistant/update', data, jsonHeaderConfig)
}
// 删除协助人
export const deleteAssistants = (data: any) => {
  return request.post('/crm/track/assistant/delete', data, jsonHeaderConfig)
}

// 获取来源
export const getHighSeasFromApi = (): Promise<CustomerManage.ReqGetCustomFromReturn[]> => {
  return request.post('/crm/openSeaAutoAssignRule/findChannelByTenant', null, jsonHeaderConfig)
}
// 获取客户跟进记录
export const getFollowRecordListApi = (
  data: any
): Promise<CustomerManage.ReqGetCustomFromReturn[]> => {
  return request.post('/crm/track/followLog/follow', data, jsonHeaderConfig)
}

// 获取客户操作记录
export const getOperateRecordListApi = (
  data: any
): Promise<CustomerManage.ReqGetCustomFromReturn[]> => {
  return request.post('/crm/track/followLog/op', data, jsonHeaderConfig)
}
// 查询操作记录事件
export const getOperateEventTypeApi = (
  data: any
): Promise<CustomerManage.ReqGetCustomFromReturn[]> => {
  return request.get('/crm/track/followLog/op/event', data, jsonHeaderConfig)
}
// 添加客户跟进记录
export const addFollowLogApi = (
  data: any,
  headers: any = undefined
): Promise<CustomerManage.ReqGetCustomFromReturn[]> => {
  return request.post(
    '/crm/track/followLog/add',
    data,
    headers ? { headers: { ...jsonHeaderConfig, ...headers } } : jsonHeaderConfig
  )
}

// 客户详情-客户资质备注修改
export const editQualificationApi = (
  data: any
): Promise<CustomerManage.ReqGetCustomFromReturn[]> => {
  return request.post('/crm/track/normal/edit/qualification_record', data)
}

// 客户详情-跟进人列表
export const followUserListApi = (data: any): Promise<CustomerManage.ReqGetCustomFromReturn[]> => {
  return request.get('/crm/track/followLog/follow/user/list', data, jsonHeaderConfig)
}

// 客户详情-提交客单反馈
export const addFeedback = (data: any): Promise<CustomerManage.ReqGetCustomFromReturn[]> => {
  return request.post('/crm/track/feedback/add', data, jsonHeaderConfig)
}

// 公海详情
export const getSeaManageDetail = (id: string) => {
  return request.get('/crm/track/seaManage/detail', { id }, jsonHeaderConfig)
}
// 获取客户列表数据
export const getCustomerList = (data?: any) =>
  request.post('/crm/track/normal/list', data, jsonHeaderConfig)

// 获取公海列表数据
export const getSeaList = (data?: any) =>
  request.post('/crm/track/sea/list', data, jsonHeaderConfig)

// 新增客户
export const addCustomerApi = (data?: any) =>
  request.post('/crm/track/normal/add', data, jsonHeaderConfig)

// 常用筛选
export const getCommonFilterList = (data?: any) =>
  request.get('/crm/config/organ_search_template/commonFilterList', data, jsonHeaderConfig)

// 获取新增，编辑搜索，布局组件数据
export const getPageComponentData = (data?: any) =>
  request.post('/crm/component/pageAcquire', data, jsonHeaderConfig, {
    ignoreCancelToken: true
  })

export const getPageComponentDataEchoAcquire = (data?: any) =>
  request.post('/crm/component/echoAcquire', data, jsonHeaderConfig, {
    ignoreCancelToken: true
  })

export const getPageComponentDataEchoAcquireMultiEchoAcquire = (data?: any) =>
  request.post('/crm/component/multiEchoAcquireV2', data, jsonHeaderConfig, {
    ignoreCancelToken: true
  })
export const getPageComponentDataDisplayAcquire = (data?: any) =>
  request.post('/crm/component/displayAcquire', data, jsonHeaderConfig, {
    ignoreCancelToken: true
  })

// 获取客户详情
export const getCustomerDetailByIdApi = (data?: any, headers: any = undefined) =>
  request.get(
    '/crm/track/normal/getOrderInfoById',
    data,
    headers ? { headers: { ...jsonHeaderConfig, ...headers } } : jsonHeaderConfig,
    { ignoreCancelToken: true }
  )

export const getFieldColumnList = (data?: any) =>
  request.post('/yoc_lb/table_column_config/pageColumnList', data)

export const userFlowOrderSelect = (data?: any) =>
  request.post('/yoc_lb/shop_product_flow_order/selectOrgOrdersList', data) // 列表
// 关注
export const addFocuseApi = (data?: any) =>
  request.post('/crm/track/normal/focus/add', data, jsonHeaderConfig)
// 取消关注
export const removeFocuseApi = (data?: any) =>
  request.post('/crm/track/normal/focus/remove', data, jsonHeaderConfig)
// 标签编辑
export const editTagsApi = (data?: any) =>
  request.post('/crm/track/normal/edit/tags', data, jsonHeaderConfig)
// 修改客户等级
export const editLevelApi = (data?: any) =>
  request.post('/crm/track/normal/edit/level', data, jsonHeaderConfig)

// 客户批量移入公海
export const batchRemoveSea = (data?: any) =>
  request.post('/crm-report/track/normal/batchRemoveSea', data, jsonHeaderConfig)
// 客户删除
export const customerDelete = (data?: any) =>
  request.delete('/crm-report/track/normal/del', data, jsonHeaderConfig)
// 客户阶段编辑
export const customerStageEdit = (data?: any) =>
  request.post('/crm/track/normal/edit/progress', data, jsonHeaderConfig)
// 客户阶段修改
export const updateCusStatusApi = (data?: any) =>
  request.post('/crm/track/normal/updateStatus', data, jsonHeaderConfig)
// 客户批量移交
export const customerBatchDistribute = (data?: any) =>
  request.post('/crm-report/track/normal/batchDistribute', data, jsonHeaderConfig)
// 客户批量移交进度
export const customerBatchDistributeProgress = (data?: any) =>
  request.get('/crm/track/normal/getProgress', data, jsonHeaderConfig, {
    ignoreCancelToken: true
  })
// 联系人-添加
export const addLinkInfoApi = (data?: any) =>
  request.post('/crm/track/linkInfo/add', data, jsonHeaderConfig)
// 联系人-删除
export const deleteLinkInfoApi = (id: string) => request.get(`/crm/track/linkInfo/remove/${id}`, [])
// 联系人-更新
export const updateLinkInfoApi = (data?: any) =>
  request.post('/crm/track/linkInfo/update', data, jsonHeaderConfig)
// 联系人-设为主要联系人
export const setMainLinkUserApi = (data?: any) =>
  request.post('/crm/track/linkInfo/primaryContact', data, jsonHeaderConfig)
// 联系人-列表
export const linkInfoListApi = (data?: any) => request.get('/crm/track/linkInfo/list', data)
// 联系人-校验号码是否为重复
export const checkPhoneRepeatApi = (data?: any) =>
  request.get('/crm/track/linkInfo/checkPhoneRepeat', data)
// 关联客户-添加
export const addRelevanceCustomApi = (data?: any) =>
  request.post('/crm/track/relevance/add', data, jsonHeaderConfig)
// 关联客户-列表
export const relevanceListApi = (data?: any) => request.get('/crm/track/relevance/list', data)
// 查询客户信息
export const searchOrderInfoApi = (data?: any, headers: any = undefined) => {
  // let headersConfig = FormUrlEncodedConfig
  // if (headers) {
  //   headersConfig = { headers: Object.assign(headersConfig.headers, headers) }
  // }
  // headersConfig = { headers: Object.assign(headersConfig.headers, headers) }
  return request.get(
    '/crm/track/relevance/searchOrderInfo',
    data,
    headers ? { headers: { ...FormUrlEncodedConfig, ...headers } } : FormUrlEncodedConfig
  )
}
// 删除关联客户
export const deleteRelevanceApi = (id: string) => request.get(`/crm/track/relevance/${id}`, {})
// 获取paas客户详情数据
export const getOrderBaseInfo = (data?: any, headers: any = undefined) => {
  // let headersConfig = jsonHeaderConfig
  // if (headers) {
  //   headersConfig = { headers: Object.assign(headersConfig.headers, headers) }
  // }
  return request.post(
    '/crm/track/normal/getOrderBaseInfo',
    data,
    headers ? { headers: { ...jsonHeaderConfig, ...headers } } : jsonHeaderConfig,
    { ignoreCancelToken: true }
  )
}
// 修改paas客户详情数据
export const updateOrderInfo = (data?: any) =>
  request.post('/crm/track/normal/updateOrder', data, jsonHeaderConfig, {
    ignoreCancelToken: true
  })
// 查询常用筛选数量
export const getFilterNumber = (data?: any) =>
  request.post('/crm-report/track/normal/getFilterNumber', data, jsonHeaderConfig, {
    ignoreCancelToken: true
  })
// 资质备注修改记录列表
export const qualificationRecordApi = (data?: any) =>
  request.post('/crm/track/normal/list/qualification_record', data, jsonHeaderConfig, {
    ignoreCancelToken: true
  })
// 公海管理配置-名字判重
export const seaManageCheckName = (data: { name: string; id?: string }) => {
  return request.get('/crm/track/seaManage/check/name', data)
}
// 根据id判断此客户是属于客户、回收、线索、公海等
export const getCustomerRedirectFlagApi = (data: { id: string }) => {
  return request.post('/crm/track/normal/getCustomerRedirectFlag', data, FormUrlEncodedConfig, {
    ignoreCancelToken: true
  })
}

export const getTagForEcho = (data?: any) =>
  request.post('/crm/config/saas_customer_tag_group_config/getTagForEcho', data, jsonHeaderConfig, {
    ignoreCancelToken: true
  })
// 根据id判断此客户是属于客户、回收、线索、公海等
export const updateCustomCallMarkApi = (data: Recordable) => {
  return request.post(
    '/crm/track/normal/edit/callMark',
    data,
    {
      headers: {
        ...jsonHeaderConfig,
        AppCodeField: '9c99f25a97f34da4858ea60c8adb8d'
      }
    },
    { ignoreCancelToken: true }
  )
}

// ------------------------------------添加微信相关接口-----------------------------------//

// 校验是否展示添加微信按钮
export const checkShowAddWechat = (data: Recordable) => {
  return request.post('/crm/weixin/check_permission', data, jsonHeaderConfig)
}
// 发送添加微信
export const sendAddWechat = (data: Recordable) => {
  return request.post('/crm/weixin/add_contacts', data, jsonHeaderConfig)
}

// 获取添加微信进度
export const getAddWechatProgress = (data: Recordable) =>
  request.post('/crm/track/normal/getProgress', data, jsonHeaderConfig)

// 获取微信聊天记录
export const getWechatChatRecord = (data: Recordable) =>
  request.post('/crm/weixin/chat/history/page', data, jsonHeaderConfig)

/**
 * @description 通过客户ids，判断是否有客户存在产品id
 * @param ids \客户ids
 * @returns
 */
export const checkExistProduct = (ids: string[]) =>
  request.post('/crm/track/normal/existProduct', ids, jsonHeaderConfig)

/**
 * @description 通过客户id，获取车300报告链接
 * @param data: {"customerId": 1L} 客户id
 * @returns
 */
export const getCar300ReportApi = (data: Recordable) =>
  request.post('/crm/customer/extra/data/get', data, jsonHeaderConfig)

// 客户批量移交
export const batchDistributeWithoutAuth = (data?: any) =>
  request.post('/crm-report/track/normal/batchDistributeWithoutAuth', data, jsonHeaderConfig)

// 是否展示无效号码检测
export const isShowCheckTextApi = (data: Recordable) =>
  request.post('/crm/invalid_number_feedback_record/hasPermissionOperateButton', data)

// 提交无效号码检测
export const submitCheckTextApi = (data: Recordable) =>
  request.post('/crm/invalid_number_feedback_record/save', data, jsonHeaderConfig)

// 无效号码检测列表
export const invalidNumberFeedbackRecordListApi = (data: Recordable) =>
  request.post('/crm/invalid_number_feedback_record/pageList', data, jsonHeaderConfig)

// 查询融易花机构配置
export const getRongYihuaOrgConfigApi = (data: Recordable) =>
  request.get('/ryh-product/admin/productConfig/detail', data, jsonHeaderConfig)

// 查询最近一条跟进记录
export const getLastFollowApi = (id: string) =>
  request.get(`/crm/track/aiFollowLog/getLastFollow?orderId=${id}`, {})

// 跟进记录
export const aiFollowLogList = (data?: any) =>
  request.post('/crm/track/aiFollowLog/follow', data, jsonHeaderConfig)
